<template>
  <div class="view-container">
    <div class="view-gabarit">
      <div v-if="rawStudy" class="file-uploaded">
        <i class="icon-checkstatus icon-check"></i>
        <div class="text">
          {{ $t('studyCreation.sucessFileUpload') }}
        </div>
        <i class="icon-csvfile icon-file"></i>
        <div class="container">
          <div class="file-name">{{ rawStudy.filename }}</div>
          <div class="delete" @click="goTo('studyUploadCSV')">{{ $t('delete') }}</div>
        </div>
      </div>
      <div class="view-row">
        <div class="view-description">
          <p class="baseline">{{ $t('studyCreation.filters') }}</p>
          <p class="description">{{ $t('studyCreation.filtersName') }}</p>
          <p class="description">
            {{ $t('caution') }} : <b>{{ $t('maxChar', 30, { count: 30 }) }}</b>
          </p>
        </div>
        <div class="view-content">
          <form @submit.prevent="submitForm">
            <fieldset v-if="filter1ex.length > 0 && (filter1ex[0] || filter1ex.length > 1)">
              <label for="filter1">{{ $t('filters.filter1') }}</label>
              <input id="filter1" v-model="filter1" name="filter1" type="text" :placeholder="$t('filters.filter1')" />
              <div class="filter-ex-container">
                <span class="filter-title">{{ $t('dataSample') }} :</span>
                <div class="filter-ex-gabarit">
                  <div v-for="(item, idx) in filter1ex" :key="idx" class="filter-caption">{{ item }}</div>
                </div>
              </div>
            </fieldset>

            <fieldset v-if="filter2ex.length > 0 && (filter2ex[0] || filter2ex.length > 1)">
              <label for="filter2">{{ $t('filters.filter2') }}</label>
              <input id="filter2" v-model="filter2" name="filter2" type="text" :placeholder="$t('filters.filter2')" />
              <div class="filter-ex-container">
                <span class="filter-title">{{ $t('dataSample') }} :</span>
                <div class="filter-ex-gabarit">
                  <div v-for="(item, idx) in filter2ex" :key="idx" class="filter-caption">{{ item }}</div>
                </div>
              </div>
            </fieldset>

            <fieldset>
              <button class="study-button main" type="submit">{{ $t('validate') }}</button>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      filter1: '',
      filter1ex: [],
      filter2: '',
      filter2ex: [],
    };
  },

  computed: {
    ...mapGetters({
      rawStudy: 'rawStudy',
    }),
  },

  mounted() {
    const id = this.$route.params.studyId;

    this.$store
      .dispatch('getStudyCsvFilters', {
        id,
      })
      .then(response => {
        if (response.filters1) {
          this.filter1ex = response.filters1;
        }
        if (response.filters2) {
          this.filter2ex = response.filters2;
        }

        if (
          !(this.filter1ex.length > 0 && (this.filter1ex[0] || this.filter1ex.length > 1)) &&
          !(this.filter2ex.length > 0 && (this.filter2ex[0] || this.filter2ex.length > 1))
        ) {
          this.$router.push({ name: 'studyCurrentSites' });
        }
      });
  },

  methods: {
    submitForm() {
      const id = this.$route.params.studyId;

      const payload = {};

      if (this.filter1 !== '') {
        payload.filter1_name = this.filter1;
      }

      if (this.filter2 !== '') {
        payload.filter2_name = this.filter2;
      }

      this.$store.dispatch('patchStudy', { id, payload }).then(() => {
        this.$router.push({ name: 'studyCurrentSites' });
      });
    },

    goTo(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss">
@use '@/styles/colors.scss';

.file-uploaded {
  display: flex;
  align-items: center;
  width: 100%;
  height: 96px;
  background: rgba(29, 174, 161, 0.15);
  border: 1px solid #1daea1;
  border-radius: 2px;
  margin: 0 0 24px;

  .icon-check {
    font-size: 64px;
    color: #1daea1;
  }

  .text {
    font-size: 20px;
    font-weight: 600;
    width: 30%;
    margin: 0 7% 0 0;
    color: #1daea1;
  }

  .icon-file {
    font-size: 80px;
    color: #3c3c3b;
  }

  .file-name {
    font-size: 20px;
    font-weight: 600;
    color: #3c3c3b;
    margin: 0 0 4px;
  }

  .delete {
    font-size: 16px;
    font-weight: 600;
    color: colors.$red-color;
    cursor: pointer;
    transition: 0.2s ease;

    &:hover {
      opacity: 0.7;
    }
  }
}

.filter-ex-container {
  background-color: #f8f7f7;
  color: #77797f;
  box-sizing: border-box;
  padding: 20px;
  .filter-title {
    font-size: 14px;
    font-style: italic;
  }
  .filter-ex-gabarit {
    padding: 12px 0px 0;
  }
  .filter-caption {
    font-size: 14px;
    margin-left: 24px;
    line-height: 1.5;
  }
}
</style>
